export class TaskTemplateRequest {
  status?: string;
  type?: string;
  useType?: string[];

  sortBy?: string;
  pageNumber?: number;
  pageSize?: number;
  sort?: string;
}

export function createDefaultTaskTemplatesListRequest(
  overrides?: Partial<TaskTemplateRequest>
): TaskTemplateRequest {
  return {
    sortBy: 'id',
    pageNumber: 1,
    pageSize: 10,
    sort: 'desc',
    status: '',
    type: '',
    ...overrides
  };
}
